import {
  ICallInteraction,
  IDebitmanagment,
  IRepossession,
} from "../../types/repossession.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const makeRequestDebounced = createDebounce(makeRequest, 200);
const API_URL = `${import.meta.env.VITE_API_URL}/debit-management`;

type GetDebitManagementOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  fields?: string;
};

export const getDebitManagement = async (
  options: GetDebitManagementOptions = {}
) => {
  const {
    status = [],
    search = "",
    page = 1,
    itemsPerPage = 10,
    orderBy = "",
    fields = "companyId, renter, daysOverdue, amount, status, negotiations, createdAt, updatedAt",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  params.append("pageOptions[page]", String(page));
  params.append("pageOptions[itemsPerPage]", String(itemsPerPage));

  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IDebitmanagment[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
};

export const createCallInteractions = async (
  debitmanagmentId: string,
  negotiationsId: string,
  callInteraction: ICallInteraction
) => {
  const url = `${API_URL}/create-callInteractions`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      debitmanagmentId,
      negotiationsId,
      callInteraction,
    }),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IRepossession>
  >;
};

export const sendRepossessionDebitManagement = async (
  vehicleId: string,
  overdueDays: number,
  totalDebt: number,
  renter: { _id: string; name: string; whatsapp: string }
) => {
  const url = `${API_URL}/send-repossession`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      vehicleId,
      overdueDays,
      totalDebt,
      renter,
    }),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IRepossession>
  >;
};
